/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Email_PlaceholderInputs */

const en_common_sign_email_placeholder = /** @type {(inputs: Common_Sign_Email_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email`)
};

/**
* | output |
* | --- |
* | "Enter your email" |
*
* @param {Common_Sign_Email_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_email_placeholder = /** @type {((inputs?: Common_Sign_Email_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Email_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_email_placeholder(inputs)
});
export { common_sign_email_placeholder as "common.sign.email_placeholder" }